"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportingPeriodSchema = exports.CalendarYearSchema = exports.CalendarQuarterSchema = exports.CalendarMonthSchema = exports.CalendarWeekSchema = exports.CalendarDaySchema = exports.AllReportingPeriodPropertiesIterable = exports.PeriodIterable = exports.DaySchema = exports.DayIterable = void 0;
const zod_1 = require("zod");
// Define DaySchema locally to avoid circular import with ../Date
exports.DayIterable = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday',
];
exports.DaySchema = zod_1.z.enum(exports.DayIterable);
// all resolved start and end dates are inclusive
exports.PeriodIterable = [
    // resolves to start=reportingDate; end=reportingDate
    // reportingDate 2023-10-23 => start: 2023-10-23; end: 2023-10-23;
    'calendarDay',
    // resolves to start=1st day of calendar week; end=last day of calendar week
    // optional weekStartDay parameter to set start day of week, defaults to Monday
    // reportingDate 2023-10-24 (Tuesday) => start: 2023-10-23 (Monday); end: 2023-10-29 (Sunday);
    'calendarWeek',
    // resolves to start=1st day of calendar month; end=last day of calendar month
    // reportingDate 2023-01-16 => start: 2023-01-01; end: 2023-01-31;
    'calendarMonth',
    // resolves to start=1st day of calendar quarter; end=last day of calendar quarter
    // calendar quarters: Q1=1/1-3/31; Q2=4/1-6/30; Q3=7/1-9/30; Q4=10/1-12/31
    // reportingDate 2023-01-16 => start: 2023-01-01; end: 2023-03-31;
    'calendarQuarter',
    // resolves to start=1st day of calendar year; end=last day of calendar year
    // calendar year: 1/1-12/31
    // reportingDate 2023-01-16 => start: 2023-01-01; end: 2023-12-31;
    'calendarYear',
];
// we construct ReportingPeriod data structure from encoded formula engine string
// for use within LoanTapeMetadata framework. When adding new reportingPeriod properties
// please update this const and LoanTapeMetadata framework.
exports.AllReportingPeriodPropertiesIterable = [
    'period',
    'weekStartDay',
];
// Zod schemas for ReportingPeriod discriminated union
exports.CalendarDaySchema = zod_1.z.object({
    period: zod_1.z.literal('calendarDay'),
});
exports.CalendarWeekSchema = zod_1.z.object({
    period: zod_1.z.literal('calendarWeek'),
    weekStartDay: exports.DaySchema.optional(),
});
exports.CalendarMonthSchema = zod_1.z.object({
    period: zod_1.z.literal('calendarMonth'),
});
exports.CalendarQuarterSchema = zod_1.z.object({
    period: zod_1.z.literal('calendarQuarter'),
});
exports.CalendarYearSchema = zod_1.z.object({
    period: zod_1.z.literal('calendarYear'),
});
exports.ReportingPeriodSchema = zod_1.z.discriminatedUnion('period', [
    exports.CalendarDaySchema,
    exports.CalendarWeekSchema,
    exports.CalendarMonthSchema,
    exports.CalendarQuarterSchema,
    exports.CalendarYearSchema,
]);
//# sourceMappingURL=Reporting.js.map